<template>
    <div class="checkbox" @click="toggleCheckbox">
        <div :class="['checkbox__square', {'checkbox__square_active': checked}]"></div>
        <p class="checkbox__label">{{ label }}</p>
    </div>
</template>

<script>
export default {
    props: ['label', 'checked'],
    emits: ['handle-check'],
    methods: {
        toggleCheckbox() {
            this.$emit('handle-check')
        }
    },
}
</script>

<style lang="scss" scoped>
.checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    text-align: left;
    align-self: flex-start;
    cursor: pointer;

    &__square {
        width: 24px;
        height: 24px;
        border: 1.5px solid #AEAEAE;
        border-radius: 4px;
        position: relative;

        &::before {
            content: '';
            width: 16px;
            height: 16px;
            border-radius: 4px;
            background: #aeaeae;
            transition: .3s all;
            display: block;
            position: absolute;
            top: 50%;
            left: 50%;
            transform: translate(-50%, -50%);
            opacity: 0;
            @media (max-width: 767px) {
                width: 10px;
                height: 10px;
            }
        }

        @media (max-width: 767px) {
            width: 17px;
            height: 17px;
        }

        &_active {
            &::before {
                opacity: 1;
            }
        }
    }

    &__label {
        font-family: 'Montserrat';
        font-style: normal;
        font-weight: 400;
        font-size: 18px;
        line-height: 22px;
        color: #AEAEAE;
        @media (max-width: 767px) {
            font-size: 14px;
        }
    }
}
</style>